import * as Types from '../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import { ListRolesOrganisationFragmentDoc } from './list-roles';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GroupGrantsFragment = { __typename?: 'Group', id: string, name: string, description?: string | null, grants: { __typename?: 'GrantsConnection', nodes: Array<{ __typename?: 'Grant', id: string, roleId: string, environment?: { __typename?: 'Environment', id: string, name: string } | null }> } };

export type GroupQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  organisationId: Types.Scalars['String']['input'];
}>;


export type GroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, description?: string | null, grants: { __typename?: 'GrantsConnection', nodes: Array<{ __typename?: 'Grant', id: string, roleId: string, environment?: { __typename?: 'Environment', id: string, name: string } | null }> } } | null };

export type OrganisationQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type OrganisationQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', roles: { __typename?: 'CustomRolesConnection', nodes: Array<{ __typename?: 'CustomRole', id: string, name: string, description?: string | null }> }, environments: { __typename?: 'EnvironmentsConnection', nodes: Array<{ __typename?: 'Environment', id: string, name: string, active: boolean }> } } | null };

export type SaveGroupGrantsMutationVariables = Types.Exact<{
  groupGrants?: Types.InputMaybe<Types.GroupGrantsInput>;
}>;


export type SaveGroupGrantsMutation = { __typename?: 'Mutation', setGroupGrants?: { __typename?: 'GroupGrantsPayload', group?: { __typename?: 'Group', id: string, name: string, description?: string | null, grants: { __typename?: 'GrantsConnection', nodes: Array<{ __typename?: 'Grant', id: string, roleId: string, environment?: { __typename?: 'Environment', id: string, name: string } | null }> } } | null } | null };

export const GroupGrantsFragmentDoc = gql`
    fragment GroupGrants on Group {
  id
  name
  description
  grants: grantsByOrganisationIdAndGroupId {
    nodes {
      id
      roleId
      environment {
        id
        name
      }
    }
  }
}
    `;
export const GroupDocument = gql`
    query Group($id: String!, $organisationId: String!) {
  group(id: $id, organisationId: $organisationId) {
    ...GroupGrants
  }
}
    ${GroupGrantsFragmentDoc}`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGroupQuery(baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables> & ({ variables: GroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export function useGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupSuspenseQueryHookResult = ReturnType<typeof useGroupSuspenseQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const OrganisationDocument = gql`
    query Organisation($id: String!) {
  organisation(id: $id) {
    roles: customRoles {
      nodes {
        id
      }
    }
    ...ListRolesOrganisation
  }
}
    ${ListRolesOrganisationFragmentDoc}`;

/**
 * __useOrganisationQuery__
 *
 * To run a query within a React component, call `useOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationQuery(baseOptions: Apollo.QueryHookOptions<OrganisationQuery, OrganisationQueryVariables> & ({ variables: OrganisationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
      }
export function useOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
        }
export function useOrganisationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
        }
export type OrganisationQueryHookResult = ReturnType<typeof useOrganisationQuery>;
export type OrganisationLazyQueryHookResult = ReturnType<typeof useOrganisationLazyQuery>;
export type OrganisationSuspenseQueryHookResult = ReturnType<typeof useOrganisationSuspenseQuery>;
export type OrganisationQueryResult = Apollo.QueryResult<OrganisationQuery, OrganisationQueryVariables>;
export const SaveGroupGrantsDocument = gql`
    mutation SaveGroupGrants($groupGrants: GroupGrantsInput) {
  setGroupGrants(input: $groupGrants) {
    group {
      ...GroupGrants
    }
  }
}
    ${GroupGrantsFragmentDoc}`;

/**
 * __useSaveGroupGrantsMutation__
 *
 * To run a mutation, you first call `useSaveGroupGrantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGroupGrantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGroupGrantsMutation, { data, loading, error }] = useSaveGroupGrantsMutation({
 *   variables: {
 *      groupGrants: // value for 'groupGrants'
 *   },
 * });
 */
export function useSaveGroupGrantsMutation(baseOptions?: Apollo.MutationHookOptions<SaveGroupGrantsMutation, SaveGroupGrantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGroupGrantsMutation, SaveGroupGrantsMutationVariables>(SaveGroupGrantsDocument, options);
      }
export type SaveGroupGrantsMutationHookResult = ReturnType<typeof useSaveGroupGrantsMutation>;
export type SaveGroupGrantsMutationResult = Apollo.MutationResult<SaveGroupGrantsMutation>;
export type SaveGroupGrantsMutationOptions = Apollo.BaseMutationOptions<SaveGroupGrantsMutation, SaveGroupGrantsMutationVariables>;